import React from "react";
import { Col, Row, Typography } from "antd";
import data from "./data.json"; // Assuming data.json is in the same directory

const LocationDetailsSection = () => {
  const {
    Address: addresses,
    OpenHours: hours,
    ContactNumbers: numbers,
  } = data;

  return (
    <section className="location-details-section section-margin-top">
      <div className="container">
        <Row gutter={[20, 30]}>
          <Col xs={24} md={12} lg={8}>
            <Address addresses={addresses} />
          </Col>
          <Col xs={24} md={12} lg={8}>
            <OpenHours hours={hours} />
          </Col>
          <Col xs={24} md={12} lg={8}>
            <ContactNumbers numbers={numbers} />
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default LocationDetailsSection;

const Address = ({ addresses }) => {
  return (
    <div className="loc-detail-card">
      <Typography.Title className="mt-0" level={3}>Address</Typography.Title>
      {addresses.map((address, index) => (
        <Typography.Paragraph key={index}>
          {address.street}, {address.state}, {address.zip}
          <br />
          {address.country}
        </Typography.Paragraph>
      ))}
    </div>
  );
};

const OpenHours = ({ hours }) => {
  return (
    <div className="loc-detail-card">
      <Typography.Title className="mt-0" level={3}>Open Hours</Typography.Title>
      {Object.entries(hours).map(([day, time], index) => (
        <Typography.Paragraph key={index}>
          {day}: {time}
        </Typography.Paragraph>
      ))}
    </div>
  );
};

const ContactNumbers = ({ numbers }) => {
  return (
    <div className="loc-detail-card">
      <Typography.Title className="mt-0" level={3}>Contact Numbers</Typography.Title>
      {numbers.map((number, index) => (
        <Typography.Paragraph key={index}>{number}</Typography.Paragraph>
      ))}
    </div>
  );
};
